import axios, { AxiosInstance } from "axios";
import config from "../config/config";
import {
  getLevelTestSessionId,
  LEVEL_TEST_SESSION_HEADER,
} from "@/telemetry/appInsights";

/**
 * Cria uma instância do Axios pré-configurada para um serviço específico.
 * Funcionalidades:
 * 1. Roteamento automático: mock vs API real baseado em mockServices
 * 2. Authorization header automático (Bearer token do localStorage)
 * 3. Optional X-Level-Test-Session-Id for distributed tracing correlation
 * 4. Timeout configurado
 */
export function createApiClient(serviceName: string): AxiosInstance {
  const client = axios.create({
    baseURL: config.apiBaseUrl,
    timeout: config.defaultTimeout,
  });

  client.interceptors.request.use((request) => {
    // Se o serviço está na lista de mocks, redireciona para mock server
    if (config.mockServices.includes(serviceName)) {
      request.baseURL = config.mockBaseUrl;
    }
    
    // Adiciona Authorization header automaticamente
    const token = localStorage.getItem('token');
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }

    const sessionId = getLevelTestSessionId();
    if (sessionId) {
      request.headers[LEVEL_TEST_SESSION_HEADER] = sessionId;
    }
    
    return request;
  });

  return client;
}
